import { Injectable } from '@angular/core';
import jwt_decode from "jwt-decode";

@Injectable({
    providedIn: 'root'
})
export class JwtService {
    
    public decoded: JwtCaceis = null;
    public _endpoint: string[] = ["auth", "secret"];

    get endpoint() {
        return this._endpoint.join("/");
    }

    get jwt() {
        if (this.decoded == null || this.decoded == undefined) {
            return "";
        }
        return this.decoded.dynamicSecret;
    }

    get cryptoKey(): string {
        if (this.decoded == null || this.decoded == undefined) {
            return "";
        }
        return this.decoded.dynamicSecret;
    }

    /**
     * 
     * @param jwt
     * @returns JWT decoded as JwtCaceis
     */

    public updateJwt(jwt: string): JwtCaceis {

        try {
            this.decoded = jwt_decode<JwtCaceis>(jwt);
            return this.decoded;
        } catch (Error) {
            return null;
        }
    }

    public getToken(): string {
        return localStorage.getItem('msal.idtoken');
    }
}

interface JwtCaceis {
    dynamicSecret: string;
}